(function($) {
    var windowHeight = $(window).height();

    $(document).ready(function () {
        home();
        tiles();
        gallery();
        $(window).trigger('scroll');
    });

    function home() {

        $(window).load(function () {
            $('.box').each(function(index){
                var self = this;
                setTimeout(function () {
                    $(self).addClass( "visible" );
                }, index*400);
            });
        });

        $('.slider').each(function(index){

            $(this).slick({
                slidesToShow : 1,
                slidesToScroll : 1,
                dots: false,
                arrows: true,
                prevArrow: $('.prev-arrow-' + (index + 1).toString()),
                nextArrow: $('.next-arrow-' + (index + 1).toString()),
            });
        });
    }

    function tiles() {

        $('.map-link').click(function(){
            var id = $(this).data('id');

            $('#map-' + id.toString()).parent().toggleClass('visible');

            if (breakpoint() != 'lg' && breakpoint() != 'md' && breakpoint() != 'xl') {
                var target = $('#map-' + id.toString()).parent();
                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top - 0.4 * $(window).width()
                    }, 1000);
                    return false;
                }
            }
        });

        $('.close-map').click(function(){
            $(this).parent().removeClass('visible');
        });

        $(window).scroll(function () {
            $('.tile-list-item').each(function(){
                if (isScrolledIntoView($(this))) {
                    $(this).addClass('visible');
                }
            });
        });

    }

    function gallery(){
        $(window).load(function () {

            $('.gallery-item').each(function(index){
                var self = this;
                setTimeout(function () {
                    $(self).addClass( "visible" );
                }, index*150);
            });

        });
    }

    function smoothScroll() {
        $('a[href*="#"]:not([href="#"])').click(function() {
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 1000);
                    return false;
                }
            }
        });
    }



    function isScrolledIntoView(elem) {
        if (elem.length){
            if (elem.height() < windowHeight){
                if (elem.offset().top < $(window).scrollTop() + windowHeight * 0.45 && elem.offset().top > $(window).scrollTop() + windowHeight * 0.1 ) {
                    return true;
                }
            }else{
                if (elem.offset().top < $(window).scrollTop() + windowHeight * 0.9){
                    return true;
                }
            }
        }
    }
})(jQuery);
function breakpoint(args) {
    function detect() {
        var width = parseInt(getComputedStyle(document.querySelector('.wrapper')).width);

        if (width < 520) {
            return 'xs';
        }
        if (width > 519 && width < 768) {
            return 'sm';
        }
        if (width > 767 && width < 992) {
            return 'md';
        }
        if (width > 991 && width < 1170) {
            return 'lg';
        } else {
            return 'xl';
        }

    }

    var current = detect();

    if (args === undefined || args.length === 0) {
        return current;
    }

    for (var i = 0; i < args.length; i++) {
        if (args[i] === current) {
            return true;
        }
    }

    return false;
}
function gmaps() {
    function initialize() {
        setTimeout(function(){
            for (var i = 0; i < maps.length; i++) {
                var map = new google.maps.Map(document.getElementById(maps[i].container), {
                    center: maps[i].center,
                    zoom: maps[i].zoom,
                    scrollwheel: false,
                    fullscreenControl: false
                });

                new google.maps.Marker({
                    position: new google.maps.LatLng(maps[i].lat, maps[i].lng),
                    map: map
                });
            }
        }, 1300);
    }

    google.maps.event.addDomListener(window, 'load', initialize);
}
